import Platform from './platform-client';

export { Platform };
